(function () {
  'use strict';
  if (window.jdLeadTrackingLoaded) return;
  window.jdLeadTrackingLoaded = true;
  var params = new URLSearchParams(location.search);
  var test = params.get('jd_tracking_test') === '1';
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var sourceKey = 'jd_source_v1';
  var pendingKey = 'jd_pending_lead_v1';
  var queue = [];
  var metaOwned = false;
  function ensureMeta() {
    if (!allowed('marketing') || test) return false;
    if (typeof window.fbq === 'function') return true;
    var fbq = window.fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    metaOwned = true;
    fbq('set', 'autoConfig', false, '3706645272992725');
    fbq('init', '3706645272992725');
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    return true;
  }
  function contactForms() {
    return Array.prototype.filter.call(document.querySelectorAll('form'), function (form) {
      var kind = form.querySelector('input[name="form_type"]');
      return form.id === 'jd-photo-form' || (kind && kind.value === 'contact');
    });
  }
  function read(storage, key) {
    try { return JSON.parse(storage.getItem(key) || 'null'); } catch (_) { return null; }
  }
  function write(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)); } catch (_) {}
  }
  function remove(storage, key) {
    try { storage.removeItem(key); } catch (_) {}
  }
  function allowed(kind) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return false;
      return kind === 'marketing' ? privacy.marketingAllowed() && privacy.saleOfDataAllowed() : privacy.analyticsProcessingAllowed();
    } catch (_) { return false; }
  }
  function clean(value) { return String(value || '').replace(/[^a-zA-Z0-9_. -]/g, '').slice(0, 120); }
  function source() {
    var record = null;
    if (allowed('analytics')) record = read(localStorage, sourceKey);
    if (record && Date.now() - record.time > 30 * 86400000) record = null;
    if (params.get('utm_source')) {
      record = {time: Date.now(), landing_path: location.pathname};
      keys.forEach(function (key) { record[key] = clean(params.get(key)); });
      if (allowed('analytics') && !test) write(localStorage, sourceKey, record);
    }
    return record || {utm_source: 'untracked', landing_path: location.pathname};
  }
  function reference() {
    return 'JD-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function field(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value || '';
  }
  function populate(form, record, ref) {
    var contact = form.id !== 'jd-photo-form';
    keys.concat(['landing_path']).forEach(function (key) {
      field(form, contact ? 'contact[' + key + ']' : key, record[key]);
    });
    field(form, contact ? 'contact[lead_reference]' : 'lead_reference', ref);
    field(form, contact ? 'contact[test_submission]' : 'test_submission', test ? 'TEST - exclude from reporting' : 'No');
  }
  function flush() {
    queue.forEach(function (item) {
      if (!item.meta && allowed('marketing') && ensureMeta()) {
        if (metaOwned) window.fbq('consent', 'grant');
        window.fbq('trackSingleCustom', '3706645272992725', item.metaName, item.data, {eventID: item.id});
        item.meta = true;
      }
      if (!item.ga && allowed('analytics') && typeof window.gtag === 'function') {
        var data = Object.assign({}, item.data, {send_to: 'G-KTR9PSEHXF'});
        window.gtag('event', item.gaName, data);
        item.ga = true;
      }
    });
    queue = queue.filter(function (item) { return !(item.meta && item.ga); });
  }
  function emit(metaName, gaName, type, ref, isTest) {
    var data = {form_type: type, page_path: location.pathname};
    document.documentElement.setAttribute('data-jd-last-event', metaName);
    document.documentElement.setAttribute('data-jd-test-event', isTest ? 'true' : 'false');
    if (isTest) return;
    queue.push({metaName: metaName, gaName: gaName, data: data, id: ref || reference(), meta: false, ga: false});
    flush();
  }
  function verify(type, token) {
    var pending = read(sessionStorage, pendingKey);
    if (!pending || pending.type !== type || pending.path !== location.pathname || Date.now() - pending.time > 1800000) return;
    if (type === 'photo_quote' && token !== pending.id) return;
    remove(sessionStorage, pendingKey);
    emit('JDLeadVerified', 'jd_lead_verified', type, pending.id, pending.test);
  }
  function ready() {
    if (!test && allowed('marketing')) ensureMeta();
    var forms = contactForms();
    forms.forEach(function (form) {
      var ref = reference();
      populate(form, source(), ref);
      function rememberAttempt() {
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
        var type = form.id === 'jd-photo-form' ? 'photo_quote' : 'contact_inquiry';
        populate(form, source(), ref);
        write(sessionStorage, pendingKey, {id: ref, type: type, path: location.pathname, time: Date.now(), test: test});
        if (type === 'photo_quote') {
          var next = form.querySelector('input[name="_next"]');
          if (next) next.value = location.origin + location.pathname + '?sent=1&jd_lead=' + encodeURIComponent(ref);
          if (test) field(form, '_subject', 'TEST ONLY - Joseph Diamonds tracking verification');
        }
      }
      form.addEventListener('submit', rememberAttempt, true);
      window.addEventListener('submit', function (event) {
        if (event.target === form) rememberAttempt();
      }, true);
      window.addEventListener('click', function (event) {
        var button = event.target.closest && event.target.closest('button, input[type="submit"]');
        if (button && button.form === form && (!button.type || button.type === 'submit')) rememberAttempt();
      }, true);
      window.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && event.target.form === form && event.target.tagName !== 'TEXTAREA') rememberAttempt();
      }, true);
    });
    if (document.querySelector('[data-jd-contact-success]')) verify('contact_inquiry');
    if (params.get('sent') === '1') verify('photo_quote', params.get('jd_lead'));
    var lastClick = {};
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var type, metaName, gaName;
      if (/^tel:/i.test(href)) { type = 'phone_click'; metaName = 'JDPhoneClick'; gaName = 'jd_phone_click'; }
      else if (/^mailto:/i.test(href)) { type = 'email_click'; metaName = 'JDEmailClick'; gaName = 'jd_email_click'; }
      else {
        try {
          var url = new URL(href, location.origin);
          if (url.hostname === 'calendar.google.com' && url.pathname.indexOf('/calendar/appointments/') === 0) {
            type = 'booking_link_click'; metaName = 'JDBookingClick'; gaName = 'jd_booking_click';
          }
        } catch (_) {}
      }
      if (!type || Date.now() - (lastClick[type] || 0) < 1000) return;
      lastClick[type] = Date.now();
      emit(metaName, gaName, type, null, test);
    });
    flush();
    var attempts = 0;
    var timer = window.setInterval(function () {
      flush();
      attempts++;
      if (attempts >= 20) window.clearInterval(timer);
    }, 500);
  }
  function refreshSource() {
    if (metaOwned && !allowed('marketing')) window.fbq('consent', 'revoke');
    if (!test && allowed('marketing')) ensureMeta();
    source();
    contactForms().forEach(function (form) {
      var existing = form.querySelector('input[name="lead_reference"], input[name="contact[lead_reference]"]');
      populate(form, source(), existing ? existing.value : reference());
    });
    flush();
  }
  document.addEventListener('visitorConsentCollected', refreshSource);
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
      if (!error) refreshSource();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
